import imageParser from './image';
import actionParser from '../props/action';
import textParser from '../props/text';
import { TEXT_STYLE } from '../props/text-style';
import { DEFAULT_BUTTON_BACKGROUND_COLOR } from '../const';
import { WEIGHT } from '../../const';

/**
 * Парсер елемента div-button-element
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-buttons-block.json
 * @param  {Object} element
 * @return {Object}
 */
export default (function (element) {
    var text = textParser(element.text);
    var image = imageParser(element.image);

    if (!text && !image) {
        return null;
    }

    var action = actionParser(element);

    if (!action) {
        return null;
    }

    return {
        image: image,
        text: text,
        textStyle: TEXT_STYLE.button,
        action: action,
        backgroundColor: element.background_color || DEFAULT_BUTTON_BACKGROUND_COLOR,
        type: element.type,
        weight: WEIGHT.button
    };
});